module.exports = __webpack_public_path__ + "img/mes-feature-responsive.aa352b8a.png";